var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96875 6.48486C5.96875 6.04974 6.1416 5.63244 6.44928 5.32477C6.75695 5.01709 7.17425 4.84424 7.60938 4.84424H27.2969C27.732 4.84424 28.1493 5.01709 28.457 5.32477C28.7646 5.63244 28.9375 6.04974 28.9375 6.48486V9.76611C28.9375 10.2012 28.7646 10.6185 28.457 10.9262C28.1493 11.2339 27.732 11.4067 27.2969 11.4067C26.8618 11.4067 26.4445 11.2339 26.1368 10.9262C25.8291 10.6185 25.6562 10.2012 25.6562 9.76611V8.12549H19.0938V27.813H21.8281C22.2632 27.813 22.6805 27.9858 22.9882 28.2935C23.2959 28.6012 23.4688 29.0185 23.4688 29.4536C23.4688 29.8887 23.2959 30.306 22.9882 30.6137C22.6805 30.9214 22.2632 31.0942 21.8281 31.0942H13.0781C12.643 31.0942 12.2257 30.9214 11.918 30.6137C11.6104 30.306 11.4375 29.8887 11.4375 29.4536C11.4375 29.0185 11.6104 28.6012 11.918 28.2935C12.2257 27.9858 12.643 27.813 13.0781 27.813H15.8125V8.12549H9.25V9.76611C9.25 10.2012 9.07715 10.6185 8.76947 10.9262C8.4618 11.2339 8.0445 11.4067 7.60938 11.4067C7.17425 11.4067 6.75695 11.2339 6.44928 10.9262C6.1416 10.6185 5.96875 10.2012 5.96875 9.76611V6.48486Z",
    fill: "#623CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextactiveIcon);
export default __webpack_public_path__ + "static/media/textactiveIcon.2fb2df25252b4ebb735d56a0461c292d.svg";
export { ForwardRef as ReactComponent };